import React from 'react';
import { Phone } from './phone';
import { Warning } from './warning';
import { FacebookLogo } from './facebook-logo';
import { TwitterLogo } from './twitter-logo';
import { YoutubeLogo } from './youtube-logo';
import { InstagramLogo } from './instagram-logo';
import { Close } from './close';
import { Cross } from './cross';
import {
	ChevronDown,
	ChevronUp,
} from './chevron';

const Svg: { [key: string]: React.FC } = {
	phone: Phone,
	facebook: FacebookLogo,
	twitter: TwitterLogo,
	youtube: YoutubeLogo,
	instagram: InstagramLogo,
	close: Close,
	cross: Cross,
	chevronDown: ChevronDown,
	chevronUp: ChevronUp,
	warning: Warning,
};

interface SvgIconProps {
	svgName: string;
	color?: string;
	hover?: string;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ svgName }) => {
	return (
		<>
			{svgName === 'phone' && <Phone />}
			{svgName === 'facebook' && <FacebookLogo />}
			{svgName === 'twitter' && <TwitterLogo />}
			{svgName === 'youtube' && <YoutubeLogo />}
			{svgName === 'instagram' && <InstagramLogo />}
			{svgName === 'close' && <Close />}
			{svgName === 'cross' && <Cross />}
			{svgName === 'chevronDown' && <ChevronDown />}
			{svgName === 'chevronUp' && <ChevronUp />}
			{svgName === 'warning' && <Warning />}
		</>
	);
};

export default Svg;
